import { IGenericRepository } from "./IGenericRepository";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { Observable, throwError, of } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { environment } from "src/app/globals";
import { Router, ActivatedRoute } from "@angular/router";
import { Inject } from "@angular/core";



export abstract class GenericRepository<T> implements IGenericRepository<T> {


    reqHeader = new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem('userToken') });

    constructor(private httpClient: HttpClient,
        private endpoint: string,
        private endUrl: string) 
        {
    
        }
    httpOptions: any;

    Post(item: any): Observable<any> {
        return this.httpClient.post(this.endUrl + this.endpoint, item, { headers: this.reqHeader }).pipe(map(this.extractData), catchError(this.handleError));
    }


    extractData(res: Response) {
        let body = res;
        return body || {};
    }

    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
        }
        else {
             // server-side error
            if (error.status === 401) {
                window.location.href = "/Login";
                localStorage.removeItem('userToken');
            }
        }
        return throwError(errorMessage);
    }
}
